export default "__VITE_ASSET__DveqWiIc__"